import React, { useState } from "react";
import styled from "styled-components";
import Burger from "./small-component/Burger.jsx";
import logo from "../assets/img/logo_only.png";

const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BrandLogo = styled.a`
height:60;
  align-items:center;
 
  padding: 8px 0;
  text-decoration: none;
  color: black;
  font-weight:bold;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-direction:row;

  h6{
    font-weight:bold;
    margin-left:10px;
  }

  img{
    width:40px;
    height:40px;
    filter:hue-rotate()
    
  }

  
`;

const HeaderWrapper = styled.header`
  display: block;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  transition: all 0.5s;
  z-index: 9999;
`;

export default function Header() {
  const [onTop, setOnTop] = useState(true);

  document.addEventListener("scroll", () => {
    var position = window.scrollY;
    if (position >= 100) {
      setOnTop(false);
    } else {
      setOnTop(true);
    }
  });

  return (
    <>
      <HeaderWrapper className={onTop ? "headerBG" : "headerBG"}>
        <NavWrapper className="container">
          <div className="nav__left">
            <BrandLogo href="##">
              <img src={logo} alt="logo" />
              <h6>Aligator IT Solutions</h6>
            </BrandLogo>
          </div>
          <div className="nav__right">
            <Burger />
          </div>
        </NavWrapper>
      </HeaderWrapper>
    </>
  );
}
